import React from 'react';

/** Step 6 — optional "Request a Quote" form. OFF until the agent turns it on. */
export default function ContactStep({ ctx }) {
  const { page, patch } = ctx;
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Contact</h3>
      <label className="flex cursor-pointer items-start gap-3">
        <input
          type="checkbox"
          className="mt-1 h-4 w-4"
          checked={page.showQuoteForm}
          onChange={(e) => patch({ showQuoteForm: e.target.checked })}
          data-testid="pp-quote-toggle"
        />
        <span>
          <span className="block text-sm font-medium">Show “Request a Quote” section</span>
          <span className="block text-xs text-white/50">This will allow leads to opt in to messages. Submissions arrive in your CRM as new leads, with their consent recorded.</span>
        </span>
      </label>
    </div>
  );
}
